interface RaiseHandRequest {
  room: string
  identity: string
  isHandRaised: boolean
  livekitUrl: string
  broadcastName?: string
}

export async function sendRaiseHandRequest(
  { livekitUrl, ...body }: RaiseHandRequest,
  request: typeof fetch = fetch,
): Promise<void> {
  const response = await request(`/api/raise_hand?livekit_url=${encodeURIComponent(livekitUrl)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  if (!response.ok) throw new Error(`Hand raise request failed (${response.status})`)
}
